<template>
  <div class="preservice-detail">
    <v-card class="preservice-detail-card" flat>
      <v-card-text>
        <div class="flex my-4 mb-4">
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Full Name:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ values.firstName ? values.firstName : "-" }}
              {{ values.fatherName ? values.fatherName : "-" }}
              {{ values.grandFatherName ? values.grandFatherName : "-" }}
            </p>
          </div>
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Sex:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ values.sex ? values.sex : "-" }}
            </p>
          </div>
        </div>
        <div class="flex my-4 mb-4">
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">National ID (FAN):</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ values.idNo ? formatFanId(values.idNo) : "-" }}
            </p>
          </div>
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Background Profession:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{
                values.backgroundProfession ? values.backgroundProfession : "-"
              }}
            </p>
          </div>
        </div>
      </v-card-text>

      <div class="preservice-detail-section-title title">
        Educational Information
      </div>

      <v-card-text>
        <div class="flex my-4 mb-4">
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">
              Department / Discipline:
            </p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ values.department ? values.department : "-" }}
            </p>
          </div>
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Program Education Type:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{
                values?.educationProgram?.name
                  ? values.educationProgram.name
                  : "-"
              }}
            </p>
          </div>
        </div>
        <div class="flex my-4 mb-4">
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Level Of Study:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ values?.levelOfStudy?.name ? values.levelOfStudy.name : "-" }}
            </p>
          </div>
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Year of Entry:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ values.entryYear ? values.entryYear : "-" }}
            </p>
          </div>
        </div>
        <div class="flex my-4 mb-4">
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">
              Expected Graduation Year:
            </p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ values?.expectedYear ? values.expectedYear : "-" }}
            </p>
          </div>
          <div class="w-1/2 h-12"></div>
          <div class="w-1/2 h-12"></div>
        </div>
        <v-card
          class="flex flex-wrap my-2 mb-6"
          outlined
          style="background-color: whitesmoke"
        >
          <div class="w-full pb-0 md:mb-0">
            <v-simple-table
              :light="dataTableLight"
              class="preservice-status-history-table"
            >
              <template
                v-if="normalizedStudentStatuses.length === 0"
                v-slot:no-data
              >
                NO DATA TO DISPLAY
              </template>
              <template v-else v-slot:default>
                <thead style="background-color: #e9ecee">
                  <tr>
                    <th width="5%">#</th>
                    <th class="text-left" width="10%">Year of Education</th>
                    <th class="text-left" width="10%">Student Status</th>
                    <th class="text-left" width="10%">GPA</th>
                    <th class="text-left" width="10%">Cumulative GPA</th>
                  </tr>
                </thead>
                <tbody style="background-color: whitesmoke">
                  <tr
                    v-for="(item, index) in normalizedStudentStatuses"
                    :key="index"
                  >
                    <td>{{ index + 1 }}</td>
                    <td>
                      <span>{{ item.yearOfEducation || "-" }}</span>
                    </td>
                    <td>
                      <span>{{ item.studentStatus || "-" }}</span>
                    </td>
                    <td>
                      <span>{{ getDisplayGpa(item) }}</span>
                    </td>
                    <td>
                      <span>{{ getDisplayCumulativeGpa(item) }}</span>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </v-card>
      </v-card-text>

      <div class="preservice-detail-section-title title">
        About University
      </div>

      <v-card-text>
        <div class="flex my-4 mb-4">
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">
              Higher Learning Institution:
            </p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ values?.university?.name ? values.university.name : "-" }}
            </p>
          </div>
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Ownership:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{
                values?.university?.ownership?.name
                  ? values.university.ownership.name
                  : "-"
              }}
            </p>
          </div>
        </div>
        <div class="flex my-4 mb-4">
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Generation Level:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{
                values?.university?.generation
                  ? values.university.generation
                  : "-"
              }}
            </p>
          </div>
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Region:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{
                values?.university?.region?.name
                  ? values.university.region.name
                  : "-"
              }}
            </p>
          </div>
        </div>
        <div class="flex my-4 mb-4">
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Town:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ values?.university?.town ? values.university.town : "-" }}
            </p>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { formatFanId } from "@/utils/fan-id";
import {
  getStudentStatusGpaItems,
  normalizeStudentStatusGpaItems,
} from "@/utils/studentStatusGpa";

const mapLegacyWithdrawalStatus = (value) => {
  const normalizedValue = (value || "").toString().trim().toLowerCase();
  if (normalizedValue === "yes") {
    return "Withdrawn";
  }
  if (normalizedValue === "no") {
    return "Active";
  }
  return value;
};

export default {
  props: {
    graduates: Object,
  },
  data() {
    return {
      values: [],
      dataTableLight: true,
    };
  },
  computed: {
    normalizedStudentStatuses() {
      const statusRows = getStudentStatusGpaItems(this.values);
      if (statusRows.length > 0) {
        return statusRows;
      }

      if (this.values?.isWithdrawn) {
        return normalizeStudentStatusGpaItems([
          {
            yearOfEducation: "Not Applicable",
            studentStatus: mapLegacyWithdrawalStatus(this.values.isWithdrawn),
            gpa: this.values.gpa,
            cumulativeGpa:
              this.values.cumulativeGpa ?? this.values.cumulative_gpa,
          },
        ]);
      }

      return [];
    },
  },
  created() {
    if (this.graduates != null) {
      this.values = this.graduates;
    }
  },
  methods: {
    formatFanId,
    getDisplayGpa(item) {
      return item?.gpa ?? "-";
    },
    getDisplayCumulativeGpa(item) {
      if (item?.cumulativeGpa != null) {
        return item.cumulativeGpa;
      }

      return "-";
    },
    getColor(status) {
      const normalizedStatus = (status || "").toString().trim().toLowerCase();
      if (
        [
          "withdrawn",
          "dismissed",
          "dropped out",
          "dropout",
          "inactive",
          "no",
        ].includes(normalizedStatus)
      ) {
        return "red";
      }
      if (
        ["graduated", "active", "enrolled", "yes"].includes(normalizedStatus)
      ) {
        return "green";
      }
      return "blue-grey";
    },
  },
};
</script>
